'use client'
import Image from 'next/image'
import DotLoader from './loaders/dot_loader'
const SplashScreen = () => {
  return (
    <div className="fixed inset-0 z-[500] flex items-center justify-center bg-app-background">
      <div className="flex flex-col items-center">
        <div className="flex flex-col items-center">
          <Image alt="logo" src="/logo.gif" width={120} height={120} />

          <span className="font-sans text-[18px] font-bold tracking-wider text-foreground">
            Cadence Calendar
          </span>
        </div>
        <DotLoader />
      </div>
    </div>
  )
}

export default SplashScreen
